module.exports = __webpack_public_path__ + "static/media/Llibre_1.afab9dde.svg";